import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { notEmpty } from 'utilities';
import { VideoPlayer } from 'components/VideoPlayer';
import { useTheme, useMediaQuery } from '@material-ui/core';

const Main = styled.div`
    .react-tabs{
        width: 100% !important;
    }
    .react-tabs__tab:hover{
        background-color: rgba(245,248,250,.8);
        color: #009ef7 !important;
    }
    .react-tabs__tab--selected{
        background-color: rgba(245,248,250,.8);
        border-radius: .475rem;
        border:0;
        color: #009ef7 !important;
    }
    .react-tabs__tab{
        border:0;
        color: #5e6278;
        font-weight: 500 !import;
        margin: 5px;
        padding: 0.5rem 0.5rem;
    }

    .relativeBox {
        position: ${(props) => props.theme.isMobile ? 'relative' : `static`};
    }

    .react-tabs__tab-list{
        border-bottom: 0;
        text-align: center;
        overflow-x: auto;
        white-space: ${(props) => props.theme.isMobile ? 'nowrap' : `unset`};
    }
    
    .react-tabs__tab-list:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 1.5rem;
      height: 100%;
      background: linear-gradient(to left,#ffffff00, #ffffff);
      border-radius: 10px;
      z-index: 1;
      display: ${(props) => props.theme.isMobile ? 'block' : `none`};
    }

    .react-tabs__tab-list:after {
      content: attr(data-text);
      position: absolute;
      top: 0;
      right: 0;
      width: 2rem;
      height: 100%;
      background: linear-gradient(to right,#ffffff00, #ffffff);
      border-radius: 10px;
      z-index: 1;
      display: ${(props) => props.theme.isMobile ? 'block' : `none`};
    }
`

const TabsIH = ({ items, panels, onSelectHandler, selectedIndex }: PropsType) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        selectedIndex && setSelectedTabIndex(selectedIndex);
    }, [selectedIndex])

    return (
        <Main theme={{ isMobile }}>
            {notEmpty(items) && notEmpty(panels) && items.length == panels.length &&
                <Tabs
                    onSelect={(index) => { onSelectHandler(index); setSelectedTabIndex(index) }}
                    selectedIndex={selectedTabIndex}>
                    <div className='relativeBox'>
                        <TabList>
                            {items.map((item, index) => (
                                <Tab key={index}
                                    style={{
                                        marginRight: index === items.length - 1 ? "1.3rem" : 0,
                                        marginLeft: index === 0 ? "0.8rem" : 0
                                    }}
                                >
                                    {item}
                                </Tab>
                            ))}
                        </TabList>
                    </div>
                    {panels.map((panel, index) => (
                        <TabPanel key={index}>{panel}</TabPanel>
                    ))}
                </Tabs>
            }
        </Main>
    )
}

type PropsType = {
    selectedIndex?: number;
    onSelectHandler: (index: number) => void;
    items: any[];
    panels: any[];
}

export default TabsIH;